module.exports = __webpack_public_path__ + "static/media/check-with-box-active-icon.8e6f0c43.svg";